import api from "./api/api";

const servicePainel = {
  getDesksPainel: async () => {
    try {
      const res = await api.get(`/desksPainelSteakHolder`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default servicePainel;
